import React from "react";
import { styled, keyframes } from "@mui/system";
import { Typography, Box, Paper } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
});

const Card = styled(Paper)({
  padding: "2rem",
  borderRadius: "16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  background: "rgba(255, 255, 255, 0.9)",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  transition: "transform 0.2s ease-in-out",
  "&:hover": {
    transform: "translateY(-5px)",
  },
});

const IconWrapper = styled("div")({
  marginBottom: "1.5rem",
  animation: `${bounce} 2s ease-in-out infinite`,
  "& svg": {
    fontSize: "4rem",
    color: "#603F97",
    animation: `${rotate} 5s linear infinite`,
  },
});

const Title = styled(Typography)({
  color: "#603F97",
  fontWeight: 600,
  marginBottom: "0.5rem",
  textAlign: "center",
});

const Subtitle = styled(Typography)({
  color: "#666",
  textAlign: "center",
  maxWidth: "300px",
  lineHeight: 1.6,
});

function WorkInProgress() {
  return (
    <Container>
      <Card elevation={0}>
        <IconWrapper>
          <ConstructionIcon />
        </IconWrapper>
        <Title variant='h4'>Under Construction</Title>
        <Subtitle variant='body1'>
          We're working hard to bring you something amazing. Please check back
          soon!
        </Subtitle>
      </Card>
    </Container>
  );
}

export default WorkInProgress;
